/* eslint-disable import/prefer-default-export */
// 判断是否是electron环境
export const IS_IN_ELECTRON = (() => {
  const userAgent = navigator.userAgent.toLowerCase();
  return userAgent.indexOf('electron') > 0;
})();
